import { useSearchParams } from 'wouter'

import { useMst } from '#hooks'
import { LEGACY_ASTERISK_DIFF } from '#util/featureFlags'

type Algorithm = 'changeset' | 'legacy'

/**
 * Attempt to read a diff algorithm override, falling back to the feature flag
 */
export function useDiffAlgorithm() {
  'use memo'

  const mst = useMst()
  const [searchParams, setSearchParams] = useSearchParams()
  const flag = mst.view.isDebugOrFlagEnabled(LEGACY_ASTERISK_DIFF)
  const override = searchParams.get('diff')

  let algorithm = flag ? 'legacy' : 'changeset'
  if (override === 'changeset' || override === 'legacy') algorithm = override

  function overrideWith(value: Algorithm | null) {
    setSearchParams((prev) => {
      if (value === null) {
        prev.delete('diff')
      } else {
        prev.set('diff', value)
      }
      return prev
    })
  }

  return { algorithm, overrideWith }
}
